class SHTProductRating extends SHTCustomComponent {
  connectedCallback() {
    let t = this.$(".js-rating");
    var e = this.$(".js-rating-count"),
      a = this.$(".js-rating-value"),
      s = this.$(".js-rating-star"),
      n =
        ((t.style.opacity = "0"), t.querySelector("[data-number-of-reviews]")),
      r = t.querySelector("[data-average-rating]");
    let i = 0;
    n &&
      ((n = parseInt(n.dataset.numberOfReviews, 10) || 0),
      (e.innerHTML =
        1 < n
          ? `(${n} ${SHTLanguage.product.PRODUCT_REVIEWS})`
          : `(${n} ${SHTLanguage.product.PRODUCT_REVIEW})`)),
      r &&
        ((e = parseFloat(r.dataset.averageRating, 10) || 0),
        Shopify.designMode || this.classList.toggle("d-none", 0 === e),
        0.3 <= (n = (a.textContent = e) % 1) && n <= 0.7
          ? (i = 0.5)
          : 0.7 < n && (i = 1),
        s) &&
        (s.style.setProperty("--rating", Math.floor(e)),
        s.style.setProperty("--rating-decimal", i)),
      (t.style.opacity = "1");
  }
}
customElements.define("sht-product-rating", SHTProductRating);
